module.exports = __webpack_public_path__ + "static/media/planejadora.ce412753.svg";